// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3ITPk","title":"InfoRow_title__3gHP9"};